import InputDate from './InputDate'

export default InputDate



// WEBPACK FOOTER //
// ./src/components/InputDate/index.js